export default __webpack_public_path__ + "static/media/demoprofile2.36193b11.svg";